import api from '../api'
import { loadInitialData } from './initialData'

function setCurrentUser(dispatch, response) {
  // save session in local storage
  localStorage.setItem('ls.session', JSON.stringify(response))
  // call identify to set userId for segment tracking
  window.analytics.identify(response.user, {})
  dispatch({ type: 'AUTHENTICATION_SUCCESS', response })
  return null
}

function clearCurrentUser(dispatch) {
  // TODO: check and list all user-related localStorage items here
  localStorage.removeItem('ls.session')
  localStorage.removeItem('plickers-tab-sync')
  localStorage.removeItem('service.product')
  localStorage.removeItem('meta.setGroup')
  localStorage.removeItem('lastViewedDiscover')
  dispatch({ type: 'LOGOUT' })
  // remove user from segment tracking
  window.analytics.reset()
}

export function login(data) {
  return (dispatch) => api.post('/sessions', data)
    .then((response) => {
      dispatch({ type: 'LOGIN_SUCCESS', response })
      setCurrentUser(dispatch, response)
      dispatch(loadInitialData(response.user))
      return response
    })
}

export function externalLogin(data) {
  const requestData = { ...data, inRichTextBeta: true }
  return (dispatch) => api.post('/sessions/external-signin', requestData)
    .then((response) => {
      dispatch({ type: 'LOGIN_SUCCESS', response })
      setCurrentUser(dispatch, response)
      dispatch(loadInitialData(response.user))
      return response
    })
    .catch(() => {})
}

export function signup(data) {
  const requestData = { ...data, inRichTextBeta: true }
  return () => api.post('/users', requestData)
    .then((response) => response)
}

export function logout() {
  return (dispatch) => api.delete('/sessions')
    .then(() => {
      clearCurrentUser(dispatch)
      window.location = '/login'
    })
    .catch(() => {})
}

export function authenticate() {
  const url = '/sessions/self'
  localStorage.removeItem('plickers-tab-sync')
  return (dispatch) => {
    dispatch({ type: 'AUTHENTICATION_REQUEST' })
    return api.fetch(url)
      .then((response) => {
        setCurrentUser(dispatch, response)
        return response
      })
      .catch(() => {
        clearCurrentUser(dispatch)
        window.location = '/login'
      })
  }
}

export const unauthenticate = () => ({ type: 'AUTHENTICATION_FAILURE' })
